import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CommunicationService } from '../services/communication.service';
import { ListingCategory } from '../classes/enums';

@Injectable()
export class LuxuryListingResolver implements Resolve<boolean> {
  constructor(private communicationService: CommunicationService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): boolean {
    this.communicationService.setCurrentListingType(ListingCategory.LUXURY);
    return true;
  }
}
